/**
 * @author Ariel
 * @desc 应用服务表单页面
 * @date 2020-08-26
 */
import React from "react";
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
import { WizTableForm } from "../../../common";
import { message } from "antd";

let { WizContainer, modelUtils } = framework_tool
let { WizCard, WizSpin, WizForm, WizRow, WizCol, WizInputNumber } = component_tool
let { Session } = utils_tool
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })

class ApplicationManageDetail extends WizContainer {
  componentName = 'applicationManageDetail';

  constructor(props) {
    super(props)
    const { history } = props
    let initialValue = {}
    let cardTitle = '新增'
    if (history.location && history.location.pathname === '/application/applicationManage/applicationManageDetailUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record
        Session.set('applicationManageInfo', initialValue)
      } else {
        initialValue = Session.get('applicationManageInfo') || {}
      }
      cardTitle = '编辑'
    }
    this.initialValue = initialValue
    let { monitorStatus } = initialValue
    let notShow = monitorStatus === 0 ? true : false
    this.state = {
      cardTitle,
      notShow: notShow,
      id:initialValue.id||''
    }
  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/application/applicationManage/applicationManageDetailUpd') {
      if (history.location.record) {
        console.log(history.location.record,'history.location.record')

        initialValue = history.location.record;
        Session.set('applicationManageInfo', initialValue)
      } else {
        initialValue = Session.get('applicationManageInfo') || {};
      }
    }
    console.log(initialValue,'initialValue')
    if (initialValue.id != this.initialValue.id) {
      this.initialValue = initialValue
      this.setState({id:initialValue.id||''})
      console.log(initialValue,'initialValue22')
    }
  }

  _componentDidMount() {
  }

  propsAndStateOnChange = {
    addApplicationManage: this._addApplicationManageOver.bind(this)
  }

  _addApplicationManageOver(nextProps, nextState) {
    if (nextProps.addApplicationManage.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/application/applicationManage');
    } else {
      wizNotice.error('提交失败：' + nextProps.addApplicationManage.msg);
    }
    return true;
  }

  _addApplicationManage(values) {
    const { history } = this.props
    let apiPath = 'applicationManage/add';
    if (history.location && history.location.pathname === '/application/applicationManage/applicationManageDetailUpd') {
      apiPath = 'applicationManage/update'
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: 'addApplicationManage',
        apiParams: { ...values }
      }
    })
  }

  _render() {
    const { applicationManageLoading } = this.props
    const { cardTitle, notShow } = this.state
    let { monitorFrequency } = this.initialValue
    if (monitorFrequency == -1) {
      monitorFrequency = null
    }
    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
          initialValue: this.initialValue.id
        }
      },
      {
        title: '应用服务',
        name: 'name',
        formItem: {
          maxLength: 20,
          placeholder: '应用服务名称最多输入20个字',
          initialValue: this.initialValue.name,
          rules: [
            {
              required: true,
              message: '请输入应用服务'
            },
            {
              pattern: /^[\u4e00-\u9fa5a-zA-z0-9\.\-\[\]_·]*$/,
              message: '应用服务名称只能包含中文、英文、数字、[、]、-、_、.、·'
            }
          ],
        }
      },
      {
        title: '所属组织',
        name: 'orgId',
        formItem: {
          ...organizationConfig,
          diy: WizTableForm,
          initialValue: this.initialValue.orgId,
          initRows: [{ ...this.initialValue, id: this.initialValue.orgId, name: this.initialValue.orgName }],
          selectType: 'radio',
          rules: [
            {
              required: true,
              message: '请选择所属组织'
            }
          ],
        }
      },
      {
        title: '来源',
        name: 'sourceType',
        formItem: {
          initialValue: this.initialValue.sourceType,
          type: 'select',
          rules: [
            {
              required: true,
              message: '请选择来源'
            }
          ],
        },
        dict: [
          { code: 0, codeName: '新培训平台' },
          { code: 1, codeName: '第三方系统' }
        ]
      },
      {
        title: '负责人',
        name: 'principalName',
        formItem: {
          maxLength: 30,
          placeholder: '负责人姓名最多输入30个字',
          rules: [
            {
              required: true,
              message: '请输入负责人姓名'
            },
            {
              pattern: /^[\u4e00-\u9fa5_a-zA-Z· ]+$/,
              message: '负责人姓名只能包含中文、英文、·、空格'
            }
          ],
          initialValue: this.initialValue.principalName
        }
      },
      {
        title: '联系电话',
        name: 'principalPhone',
        formItem: {
          maxLength: 20,
          message: '联系电话最多20位',
          rules: [
            {
              required: true,
              message: '请输入负责人联系电话'
            },
            {
              pattern: /^[0-9\-]*$/,
              message: '联系电话只能输入数字和-'
            }
          ],
          initialValue: this.initialValue.principalPhone
        }
      },
      {
        title: '监控状态',
        name: 'monitorStatus',
        formItem: {
          rules: [
            {
              required: true,
              message: '请选择监控状态'
            }
          ],
          initialValue: this.initialValue.monitorStatus != null ? this.initialValue.monitorStatus : 1,
          type: 'radio',
          onChange: (form, value, e) => {
            let notShow = value === 0 ? true : false
            this.setState({ notShow: notShow })
          }
        },
        dict: [
          { code: 1, codeName: '启用' },
          { code: 0, codeName: '禁用' },
        ]
      },
      {
        title: '监控URL',
        name: 'monitorUrl',
        formItem: {
          maxLength: 300,
          placeholder: '监控URL长度300',
          initialValue: this.initialValue.monitorUrl,
          rules: [
            {
              pattern: /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/,
              message: '请输入正确格式的URL'
            },
            {
              required: !notShow,
              message: '监控状态启用，监控URL必填'
            }
          ],
          disabled: this.state.notShow
        }
      },
      {
        title: '监控频率',
        name: 'monitorFrequency',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form;
            return (
              <WizRow>
                <WizCol span={20}>
                  {getFieldDecorator('monitorFrequency', {
                    rules: [
                      {
                        required: !notShow,
                        message: '监控状态启用，监控频率必填'
                      },
                      { pattern: /^[1-9]\d{0,38}$/, message: '数字不能过长且首位不能为0，以免影响存储效果' }
                    ],
                    initialValue: monitorFrequency,
                  })(<WizInputNumber disabled={this.state.notShow} />)}
                </WizCol>
                <WizCol span={2} className='limit-minutes-text'>秒/次</WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: '状态',
        name: 'status',
        formItem: {
          initialValue: this.initialValue.status != null ? this.initialValue.status : 1,
          type: 'radio'
        },
        dict: [
          { code: 1, codeName: '启用' },
          { code: 0, codeName: '禁用' },
        ]
      },
      {
        title: '简介',
        name: 'intro',
        formItem: {
          maxLength: 200,
          placeholder: '备注最多输入200个字',
          type: 'textarea',
          initialValue: this.initialValue.intro
        }
      }
    ]

    let onSubmit = this._addApplicationManage.bind(this)

    let formProps = {
      ref: 'form',
      key: this.state.id || '', // ⭐如缓存路由需要刷新,必须加标识key
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      },
      onReset: (f) => {
        if (f.getFieldValue('monitorStatus') === 0) {
          this.setState({ notShow: true })
        }
      }
    }
    console.log(this.initialValue,'this.initialValue')
    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={applicationManageLoading}>
          <WizForm className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { applicationManage } = state;
  const addApplicationManage = modelUtils.getModelEntity(applicationManage, 'addApplicationManage');
  const load = modelUtils.getLoadingState(state, 'applicationManage');
  return {
    addApplicationManage,
    ...load
  }
}

export default connect(mapStateToProps)(ApplicationManageDetail);
